// Copyright Open Trade Technology Ltd. 2023. All rights reserved.
//
import * as yup from 'yup'
import { InferType } from 'yup'
import { yupEthAddrRequired } from './Enums'
import { StringTypeEnum, toFieldMetaData } from './SchemaTypes'

export const PoolAccountAccessPairCTOSchema = yup.object({
  accountAddr: yupEthAddrRequired.label('accountAddr').meta(
    toFieldMetaData({
      propName: 'accountAddr',
      description: 'Wallet address of the account',
      stringType: StringTypeEnum.ETH_ADDR,
    })
  ),
  poolAddr: yupEthAddrRequired.label('Pool Address').meta(
    toFieldMetaData({
      propName: 'poolAddr',
      description: 'Vault address of the pool',
      stringType: StringTypeEnum.ETH_ADDR,
    })
  ),
})

//HERE: EXPLAIN MORE
export type PoolAccountAccessPairCTO = InferType<typeof PoolAccountAccessPairCTOSchema>
